<template>
  <IQOS :systemDependency="mode" required enabled :title="$t('preorder.payment.title')">
    <SlideToggleRow class="mt-16" v-model="pay_methods.cash" :readonly="!editing">{{$t('preorder.payment.cash')}}</SlideToggleRow>
    <p
      class="iqos-comment qrw-paragraph-md mt-8"
      v-if="mode == 'delivery'"
    >{{$t('preorder.payment.cash_courier')}}</p>
    <p
      class="iqos-comment qrw-paragraph-md mt-8"
      v-else
    >{{$t('preorder.payment.cash_about')}}</p>
    <BaseDivider color="v1-grey-4" class="mt-16"/>

    <SlideToggleRow class="mt-16" v-model="pay_methods.card" :readonly="!editing">{{$t('preorder.payment.card')}}</SlideToggleRow>
    <p class="iqos-comment qrw-paragraph-md mt-8">{{$t('preorder.payment.card_about')}}</p>
    <BaseDivider color="v1-grey-4" class="mt-16" v-if="isOnlineAvailable"/>

    <SlideToggleRow class="mt-16" v-model="pay_methods.online" :readonly="!editing" v-if="isOnlineAvailable">{{$t('preorder.payment.online')}}</SlideToggleRow>
    <p class="iqos-comment qrw-paragraph-md mt-8" v-if="isOnlineAvailable">{{$t('preorder.payment.online_about')}}</p>
  </IQOS>
</template>

<style scoped>

</style>

<script>
import SlideToggleRow from "@/components/SlideToggleRow.vue";

export default {
  data() {
    return {
      editing: true,

      pay_methods: {
        online: false,
        cash: false,
        card: false,
      },

      valid: true,
      resetted: false,
    };
  },
  props: {
    mode: {
      type: String,
      default: "delivery",
    },
  },
  watch: {
    "pay_methods.online"() {
      if (this.resetted) this.onEditFinish();
    },
    "pay_methods.cash"() {
      if (this.resetted) this.onEditFinish();
    },
    "pay_methods.card"() {
      if (this.resetted) this.onEditFinish();
    },
  },
  methods: {
    showEditUI() {
      this.editing = true;
    },
    reset() {
      const container =
        this.mode == "inside" ? this.cafe : this.cafe[this.mode];

      if (container) {
        this.pay_methods = Object.assign(
          this.pay_methods,
          container.pay_methods
        );
      }

      this.$nextTick(() => {
        this.resetted = true;
      });
    },
    hideEditUI() {
      this.editing = false;
      this.reset();
    },
    onEditFinish() {
      this.$store.commit("setCafePayMethods", {
        mode: this.mode,
        pay_methods: this.pay_methods,
      });

      this.$store.dispatch("saveCafe");

      this.valid = true;

      this.$store.dispatch("auditlog/write", {
        type: "pay_methods",
        payload: {
          mode: this.mode,
          pay_methods: this.pay_methods,
        },
      });
    }
  },
  mounted() {
    this.reset();
  },
  computed: {
    cafe() {
      return this.$store.state.cafe;
    },
    isOnlineAvailable() {
      if (this.pay_methods.online) return true;

      if (this.cafe.chain_id) {
        return true;
      }

      return this.$store.getters["readyPayReceiver"];
    },
  },
  components: {
    SlideToggleRow
  },
};
</script>
